export default __webpack_public_path__ + "static/media/yearn_background_light_no_mitch.2b117494.svg";